var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        wrapper: true,
        shouldHover: !_vm.active
      },
      style: _vm.topHeight,
      on: { mouseover: _vm.handleMouseOver, mouseout: _vm.handleMouseOut }
    },
    [
      _c(
        "div",
        {
          staticClass: "wrapper__text",
          style: {
            backgroundImage: "url(" + _vm.image.ImgthumbBlurLarge + ")",
            backgroundSize:
              _vm.width * _vm.modifier +
              "px " +
              _vm.height * _vm.modifier +
              "px",
            backgroundPosition: "bottom"
          }
        },
        [
          _c("div", {
            staticClass: "colorOverlay",
            style: {
              /* backgroundColor: badge.colors.dominant*/
              /* backgroundColor: `rgba(${$root.content.allImages[content.image].colors.Muted._rgb.join()}, 1)`, */
              /* backgroundColor: $root.content.overlayColor */
              /* background: `linear-gradient(45deg, #${content.colordark}, #${content.colorlight})`, */
              background: "#" + _vm.content.colordark
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper__text--inner" }, [
            _c("h4", [
              _vm._v("Barrier " + _vm._s(_vm.content.barrier || "TBC"))
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.content.tab) + ". " + _vm._s(_vm.content.name))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "badge" }, [
        _c("img", {
          attrs: {
            src: _vm.$root.content.badges[_vm.content.name.toLowerCase()],
            alt: _vm.content.name + " silk"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper__image" },
        [
          _c("responsive-image", {
            attrs: {
              imageFiles: _vm.image,
              image: _vm.image.Img200,
              alt: "" + _vm.content.name
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c658756", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c658756","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dally-m/games-top.vue
// module id = null
// module chunks = 